import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { DeleteTemplateVariablesMutation, DeleteTemplateVariablesMutationVariables } from '@/graphql/generated/graphql';
import { DeleteTemplateVariablesDocument } from '@/graphql/generated/graphql';
export type DeleteTemplateVariableInput = {
  ItemId: string
  isHardDelete?: boolean
}

export type DeleteTemplateVariableResponse = {
  data: {
    deleteTemplateVariables: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useDeleteTemplateVariable = () => {
  const mutation = useMutation({
    mutationKey: ['delete-template-variable'],
    mutationFn: ({ ItemId, isHardDelete = false }: DeleteTemplateVariableInput) => {
      return graphqlClient.request<DeleteTemplateVariablesMutation>(DeleteTemplateVariablesDocument,
        { ItemId, isHardDelete }
      )
    }
  })

  return {
    ...mutation,
    deleteTemplateVariable: mutation.mutate,
    deleteTemplateVariableAsync: mutation.mutateAsync,
  }
}

export const DELETE_TEMPLATE_VARIABLE_MUTATION = DeleteTemplateVariablesDocument;
